module.exports = __webpack_public_path__ + "img/vetting.hod.how_hod_can_make_more_money.75890bab.jpg";